import React from "react";
import { Card, CardContent, CardMedia, Typography, Box, Chip } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { getEnvironmentVariable } from "../../global/environmentVariables";
import { BCPCalendarDay } from "../icons/bcp/BCPIcons";
import moment from "moment";

const SYSTEM_IMAGES_CLOUDFRONT = getEnvironmentVariable("SYSTEM_IMAGES_CLOUDFRONT");

export default function CircuitTokenCard({ token, eventDetail }) {
  const navigate = useNavigate();
  
  const circuitName = token?.league?.name || token?.name || "Unnamed Circuit";
  const gameSystemName = token?.league?.gameSystem?.name || token?.gameSystem?.name || "Game System";
  const status = token?.status || "unknown";
  const eventName = eventDetail?.name || token?.event?.name;

  const getStatusColor = (status) => {
    const lowerStatus = status.toLowerCase();
    if (lowerStatus === "active") return "success";
    if (lowerStatus === "pending" || lowerStatus === "used") return "warning";
    return "error";
  };

  const handleCardClick = () => {
    navigate("/organize/tokens");
  };

  return (
    <Card 
      onClick={handleCardClick}
      sx={{ 
        height: "100%", 
        bgcolor: "background.paper",
        borderRadius: 2,
        cursor: "pointer",
        transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
        '&:hover': {
          transform: "translateY(-2px)",
          boxShadow: 3,
        },
        '& .MuiCardContent-root': {
          p: 2
        }
      }}
    >
      <CardMedia
        component="img"
        height="200"
        image={`${SYSTEM_IMAGES_CLOUDFRONT}/images/header.jpg`}
        alt={circuitName}
        sx={{
          objectFit: "cover",
          objectPosition: "center",
        }}
      />
      <CardContent>
        <Box sx={{ mb: 2 }}>
          <Typography variant="h5" component="div" gutterBottom noWrap fontWeight="700">
            {circuitName}
          </Typography>
          <Typography variant="h6" gutterBottom>
            {gameSystemName}
          </Typography>
        </Box>

        <Box sx={{ mb: 2 }}>
          <Chip
            label={status.toUpperCase()}
            size="small"
            color={getStatusColor(status)}
            sx={{ fontWeight: 600 }}
          />
        </Box>

        <Box sx={{ mb: 1 }}>
          <Typography variant="caption" color="text.secondary">
            Token created: {moment(token?.created_at).format("LL")}
          </Typography>
        </Box>
        
        {eventName && (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <BCPCalendarDay sx={{ fontSize: 20, color: 'text.secondary' }} />
            <Typography variant="body2" color="text.secondary">
              Event: {eventName}
            </Typography>
          </Box>
        )}
      </CardContent>
    </Card>
  );
} 